module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "Рекомендательные письма",
      "name": "1"
    }
  }, [_c('RecommendationLetters')], 1), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "В составе брокерских палат ...",
      "name": "2"
    }
  }, [_c('BrokerageHouses')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-766fcce3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandHistory/BrandRecommendations.vue
// module id = 968
// module chunks = 0